import AppContext from "@/contexts/appctx/app-context";
import ChevDown from "@/seed/components/elements/chev-down";
import RoundInfo from "@/seed/components/elements/round-info";
import TokenSaleHero from "@/seed/components/modules/token-sale/token-sale-hero";
import PoolContext from "@/seed/contexts/pool/pool-context";
import { getContributionReceipt } from "@/seed/utils/user-info";
// import { data as tokenSaleData } from "@/seed/shared/token/token-sale";
// import { data as seedRoundData } from "@/seed/shared/token/seed-round/round-info";
// import { data as userWalletData } from "@/seed/shared/user-wallet";
import { useContext } from "react";

const TokenPurchaseSuccess = () => {
    const { layoutContentDef, saleEvent } = useContext(PoolContext);
    const { user } = useContext(AppContext);

    if (!layoutContentDef || !saleEvent || !user) return <div>Loading</div>;
    const { ether: userWalletData, allocations } = user;

    console.log("TokenPurchaseSuccess", {
        layoutContentDef,
        saleEvent,
        user,
    });

    let purchaseSuccess;
    if (
        user.isPurchased &&
        allocations?.length &&
        layoutContentDef.tokenSaleHero.purchaseSuccess
    ) {
        // const purchaseForm = layoutContentDef.purchaseForm;
        purchaseSuccess = {
            ...layoutContentDef.tokenSaleHero.purchaseSuccess,
            // TODO: multiple event, add block explore url
            ...getContributionReceipt(allocations[0], null, saleEvent.acceptedCurrency),
            distribution: {
                ...layoutContentDef.tokenSaleHero.purchaseSuccess.distribution,
                tba: isNaN(saleEvent?.timeline?.claimTokenStart),
                time: saleEvent?.timeline?.claimTokenStart,
            },
        };
    }

    console.log("TokenPurchaseSuccess", {
        layoutContentDef,
        saleEvent,
        user,
        purchaseSuccess,
    });

    return (
        <>
            <div className="absolute">
                <section id="hero" className="bg-[url('/img/hero.png')] bg-center bg-cover">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
                <section id="user-guide" className="">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
            </div>
            <div className="absolute w-screen top-[20%] landscape:top-[30%]">
                <div className="container mx-auto flex flex-col items-center justify-center w-full">
                    <TokenSaleHero
                        data={{
                            ...layoutContentDef.tokenSaleHero,
                            countdown: {
                                ...layoutContentDef.tokenSaleHero.countdown,
                                ...saleEvent.countdown,
                            },
                            saleInfo: saleEvent,
                        }}
                        // purchaseForm={purchaseForm}
                        purchaseSuccess={purchaseSuccess}
                        userWallet={userWalletData}
                    />
                    <ChevDown />
                    <RoundInfo data={saleEvent.roundOverview} />
                </div>
            </div>
        </>
    );
};

export default TokenPurchaseSuccess;
